import React from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import Approver from './approver';
import ManagedFormGroup from 'components/form/managed_input/form_group';

import { connect } from 'react-redux';
import { addAssignee as addApprover, changeAssigneeGroup as changeApproverGroup } from './store/workflow/actions';
import { modes } from './helper';

const ApproverGroup = ({
  addApprover,
  approverGroup,
  changeApproverGroup,
  step,
}) => {
  const handleAddApprover = () => {
    addApprover(step, approverGroup);
  };

  const handleModeChange = (mode) => {
    changeApproverGroup(step, approverGroup, { mode });
  };

  return (
    <div className="d-flex gap-6 mb-3 pb-3 border-bottom">
      <ManagedFormGroup
        className="mt-2"
        label={`Approver Group ${approverGroup.index + 1}`}
        name={`approverGroupMode-${step.index}-${approverGroup.index}`}
        options={modes}
        type="radioGroup"
        value={approverGroup.mode}
        onValueChange={handleModeChange}
      />

      <div className="flex-fill d-flex flex-column gap-3">
        {approverGroup.assignees.map((approver) => {
          return (
            <Approver
              approver={approver}
              approverGroup={approverGroup}
              key={approver.key}
              step={step}
            />
          );
        })}

        <AddControl aria-label="add-approver" onClick={handleAddApprover}>Add Approver</AddControl>
      </div>
    </div>
  );
};

ApproverGroup.propTypes = {
  addApprover: PropTypes.func.isRequired,
  approverGroup: PropTypes.shape({
    assignees: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired
    })).isRequired,
    index: PropTypes.number.isRequired,
    mode: PropTypes.oneOf(['and_condition', 'or_condition']).isRequired
  }).isRequired,
  changeApproverGroup: PropTypes.func.isRequired,
  step: PropTypes.object.isRequired
};

const mapDispatchToProps = {
  addApprover,
  changeApproverGroup,
};

export default connect(null, mapDispatchToProps)(ApproverGroup);
